"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var catrunEgg = {
    name: "catrun",
    enabled: false,
    trigger: {
        type: "keys",
        keystrokes: ["c", "a", "t", "r", "u", "n"],
        captureOnInputs: false
    },
    onStart: function () {
        var data = "https://i.imgur.com/QfJZlrI.gif";
        var shock = document.createElement("div");
        var img = new Image();
        img.src = data;
        img.style.width = "450px";
        img.style.height = "350px";
        img.style.transition = "6s all linear";
        img.style.position = "fixed";
        img.style.left = "-400px";
        img.style.bottom = "0px";
        img.style.zIndex = "999999";
        document.body.appendChild(img);
        // window.setTimeout(function(){
        //   img.style.left = 'calc(50% - 200px)'
        // },50)
        window.setTimeout(function () {
            img.style.left = "calc(100% + 500px)";
        }, 50);
        window.setTimeout(function () {
            img.parentNode.removeChild(img);
        }, 6000);
    },
};
exports.default = catrunEgg;
